<template>
  <div class="dicom-wrapper">
    <div class="header">
      <v-btn
        v-if="!isSharedProfileView"
        color="#c5c5c5"
        height="40"
        width="50"
        min-width="50"
        style="margin-right: 10px; margin-top: 7px"
        @click="this.toggleSharingModal"
      >
        <v-icon size="25"> mdi-share </v-icon>
      </v-btn>

      <v-btn
        color="#c5c5c5"
        height="40"
        width="50"
        min-width="50"
        @click="handleClose"
        style="margin-top: 7px"
      >
        <v-icon size="25"> mdi-close-thick </v-icon>
      </v-btn>
    </div>
    <iframe
      v-if="patientId && studyId"
      :src="`${baseURL()}/dicom/pacs/patient/${patientId}/study/${studyId}?X-Ciitizen-Token=${token()}${
        grantor ? `&grantor=${grantor}` : ''
      }`"
      class="responsive-iframe"
      id="dicom-viewer"
      @load="onLoad"
      v-show="iframe.loaded"
    />
    <ShareModel
      :opened="shareModalOpened"
      :userId="getUserId"
      @toggleSharingModal="toggleSharingModal"
      :documentToShare="doc"
    />
  </div>
</template>

<script>
import { Config } from '@ciitizen/api'
import { Utils } from '../../ciitizen-component-library'
import ShareModel from '../share-model.vue'

export default {
  name: 'PacsViewer',
  props: {
    patientId: {},
    studyId: {},
    grantor: {
      type: String,
      default: null
    },
    role: {
      type: String,
      default: 'user'
    },
    description: {
      type: String
    },
    getUserId: {
      type: String,
      default: null
    },
    sharingToken: {
      type: String,
      default: null
    },
    isSharedProfileView: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    doc() {
      return { id: this.studyId, resourceType: 'ImagingStudy', description: this.description }
    }
  },
  components: {
    ShareModel
  },
  data() {
    return {
      iframe: {
        loaded: false
      },
      shareModalOpened: false
    }
  },
  methods: {
    onLoad() {
      this.iframe.loaded = true
    },
    token() {
      return this.grantor ? this.sharingToken : localStorage.getItem('default_auth_token')
    },
    handleClose() {
      document.getElementById('app').style.backgroundColor = '#FFFFFF'
      this.$router.push({
        path: '/' + localStorage.getItem('currentPath')
      })
    },
    baseURL() {
      return Config
    },
    toggleSharingModal() {
      this.shareModalOpened = !this.shareModalOpened
    }
  },
  mounted() {
    document.getElementById('app').style.backgroundColor = '#F1F1F7'
  },
  beforeDestroy() {
    document.getElementById('app').style.backgroundColor = '#FFFFFF'
  }
}
</script>

<style>
.dicom-wrapper {
  margin: -40px -16px;
}
.header {
  top: 0;
  z-index: 1;
  background: grey;
  width: 100%;
  padding: 10px;
  height: 70px;
  text-align: end;
}
.responsive-iframe {
  top: -53px;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: 0;
}
</style>
